var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.disabled && _vm.showList
      ? _c(
          "div",
          { class: _vm.className },
          _vm._l(_vm.showList, function(item, index) {
            return _c("div", { key: index, staticClass: "spaceLeft" }, [
              _c(
                "div",
                { staticClass: "ellipsis", staticStyle: { flex: "1" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(item && (item.fileNm || item.name)) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "icon img-icon",
                  staticStyle: { "margin-left": "10px", color: "#096dd9" },
                  attrs: { "aria-hidden": "true", title: "下载" },
                  on: {
                    click: function($event) {
                      return _vm.downFile(item)
                    }
                  }
                },
                [_c("use", { attrs: { "xlink:href": "#gold-icon-xiazai" } })]
              )
            ])
          }),
          0
        )
      : _c(
          "div",
          { class: _vm.className },
          [
            _c(
              "a-upload",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hideButtonHasFiles
                      ? _vm.fileList.length == 0
                      : true,
                    expression:
                      "hideButtonHasFiles ? fileList.length == 0 : true"
                  }
                ],
                attrs: {
                  accept: _vm.accept,
                  multiple: _vm.limit > 1,
                  "file-list": _vm.fileList,
                  "before-upload": _vm.beforeFileUpload,
                  remove: _vm.handleFileRemove,
                  customRequest: _vm.handleFileUpload,
                  disabled: _vm.disabled || _vm.fileList.length >= _vm.limit,
                  showUploadList: false
                }
              },
              [
                _c(
                  "a-button",
                  {
                    staticClass: "spaceLeft",
                    staticStyle: { color: "#1990ff" }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "icon img-icon",
                        attrs: { "aria-hidden": "true" }
                      },
                      [
                        _c("use", {
                          attrs: { "xlink:href": "#gold-icon-shangchuan" }
                        })
                      ]
                    ),
                    _vm._v("上传文件\n      ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.fileListShow
              ? _c(
                  "div",
                  { staticClass: "file-list" },
                  _vm._l(_vm.fileList, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.uid,
                        staticClass: "spaceLeft file-list-item"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "ellipsis",
                            staticStyle: { flex: "1" }
                          },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        _vm._v(" "),
                        _c("a-icon", {
                          staticStyle: {
                            "margin-left": "10px",
                            color: "#ef763c"
                          },
                          attrs: { type: "delete" },
                          on: {
                            click: function($event) {
                              return _vm.handleFileRemove(item)
                            }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4596a22c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4596a22c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/file-upload/file-upload.vue
// module id = l3MN
// module chunks = 1